import React from 'react'

class PauseButton extends React.Component {

    render() {
        return <button onClick={() => this.props.pauseGame() }>Stop Auto</button>
    }
}

export default PauseButton